import { ConfigConstants } from '@evorait/pace-core';

export interface DocBoxListModel {
    DocBoxId: string;
    DocType: string;
    ReportType: string;
    PrintNumber: string;
    Title: string;
    Date: string;
    CreatedBy: string;
    OrderNumber: string;
    ReportStatus: string;
    FileType: string;
    Funcloc: string;
    Material: string;
    SerialNo: string;
    EquipmentNumber: string;
    Notification: string;
    NotificationType: ConfigConstants.NotificationTypes;
    Language: string;
    Description: string;
}

export interface ODocBoxUploadModel {
    [key: string]: unknown;
    Attachment: string;
    ContentType: string;
    DocumentType: string;
    FileName: string;
    MaterialNumber: string;
    SerialNumber: string;
    Name: string;
    ProtectionClass: string;
    DocumentState?: string;
    Printno?: string;
    SourceSystem?: string;
    Salesorg?: string;
    Plant?: string;
    Country?: string;
    Notification?: string;
    NotificationType?: ConfigConstants.NotificationTypes;
    Orderno?: string;
    Funcloc: string;
    EquipmentNumber: string;
    StartDate: string;
    Language?: string;
    Description?: string;
    TaskNumber?: string;
    PaperworkUpload?: string;
    SapID?: string;
    ReportType?: string;
}

export const initialDocBoxModel: DocBoxListModel = {
    DocBoxId: '',
    DocType: '',
    ReportType: '',
    PrintNumber: '',
    Title: '',
    Date: '',
    CreatedBy: '',
    OrderNumber: '',
    ReportStatus: '',
    FileType: '',
    Funcloc: '',
    Language: '',
    Material: '',
    SerialNo: '',
    EquipmentNumber: '',
    Notification: '',
    NotificationType: ConfigConstants.NotificationTypes.Unknown,
    Description: '',
};

export interface ODocBoxUploadResponse {
    rFileId: string;
    rDocboxIentifier: string;
    rHttpCode: string;
    rStatusText: string;
    rMessage: string;
    Attachment: string;
    Causecode: string;
    ContentType: string;
    Contractno: string;
    Country: string;
    Createdat: string;
    Createdby: string;
    Customer: string;
    Customername: string;
    Description: string;
    DocumentState: string;
    DocumentType: string;
    EndDate: string;
    EquipmentNumber: string;
    FileIdentifier: string;
    FileName: string;
    Funcloc: string;
    Language: string;
    MaterialNumber: string;
    Name: string;
    Notification: string;
    NotificationType: string;
    Orderno: string;
    Plant: string;
    Printno: string;
    ProtectionClass: string;
    Salesorg: string;
    SerialNumber: string;
    SourceSystem: string;
    StartDate: string;
    StorageLocation: string;
    TaskNumber: string;
    PaperworkUpload: string;
    SapID: string;
    ReportType: string;
}

export enum DocBoxResponseStaus {
    Success = 'Success',
    Rejected = 'Rejected',
}
